module.exports = __webpack_public_path__ + "img/waving-hand.f0c9feb9.svg";